import { Button } from "@mui/material"


export const NotFound = () => {
  return (
    <div>
      <h1>Página no encontrada</h1>
      <Button
        color="primary"
        variant="contained">
          Nuevo
      </Button>
    </div>
  )
}
